import { render, staticRenderFns } from "./order-return.vue?vue&type=template&id=6bf0a384&scoped=true"
import script from "./order-return.vue?vue&type=script&lang=js"
export * from "./order-return.vue?vue&type=script&lang=js"
import style0 from "./order-return.vue?vue&type=style&index=0&id=6bf0a384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf0a384",
  null
  
)

export default component.exports